import Application from "../../Application";
import { IReportingPeriodPermission } from "../../model/reporting/ReportingPeriodPermission";
import { IApplicantService } from "../../service/applicant/ApplicantService";

export default class CreateReportingPeriodPermissionInteractor {
  private application: Application;
  private applicantService: IApplicantService;

  constructor(application, applicantService) {
    this.application = application;
    this.applicantService = applicantService;
  }

  async execute(
    applicantId: number,
    reportingPeriodPermission: IReportingPeriodPermission
  ) {
    return this.applicantService.createApplicantReportingPeriodPermission(
      applicantId,
      reportingPeriodPermission
    );
  }
}
